export default angular
  .module("ShortenFilter", [])
  .filter("shorten", () => (input, limit) => {
    input = input || "";

    if (input.length > limit) {
      return `${input.substring(0, limit - 3)}...`;
    }
    return input;
  });
